import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Code from './Code';
import Password from './Password';

export default function Auth() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/code" element={<Code />} />
            <Route path="/password" element={<Password />} />
        </Routes>
    );
}
